module.exports = __webpack_public_path__ + "resources/img/img_goldilocks_m.b3d60024560d543bcf84e32f81c981d6.png";